import { render, staticRenderFns } from "./HeadHelp.vue?vue&type=template&id=1a2fb980&scoped=true&"
var script = {}
import style0 from "./HeadHelp.vue?vue&type=style&index=0&id=1a2fb980&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a2fb980",
  null
  
)

export default component.exports